import { useTranslations } from "@jugl-web/utils";
import { forwardRef } from "react";
import { RoundedButton, RoundedButtonProps } from "../RoundedButton";
import { ReactComponent as PlayIcon } from "./assets/play.svg";

export const PlayTimerButton = forwardRef<
  HTMLButtonElement,
  Partial<RoundedButtonProps>
>(({ size = "md", ...props }, ref) => {
  const { t } = useTranslations();

  return (
    <RoundedButton
      ref={ref}
      size={size}
      color="#1A75D2"
      icon={<PlayIcon />}
      hint={t({
        id: "tasks-page.start-timer",
        defaultMessage: "Start timer",
      })}
      {...props}
    />
  );
});
